import React, { useMemo, useState } from 'react'
import { ExpandMoreOutlined } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from '@mui/material'
import SmartPaletteItem from './SmartPaletteItem'
import SmartSearch from '../formComponent/Search'
import SmartPaletteSection from './SmartPaletteSection'

const SmartPalette = ({
  sections = [],
  renderItem = ({ section, item, label, dragProperties, disabled, onClick, selected, checked, onCheckedChange }) =>
    <SmartPaletteItem
      key={section.id + '-' + label}
      label={label}
      dragProperties={dragProperties}
      disabled={disabled}
      onClick={onClick}
      selected={selected}
      checked={checked}
      onCheckedChange={onCheckedChange}
    />,
  getLabel = (section, item) => item?.code,
  isItemDisabled = (section, item) => false,
  areSameItem = (section1, item1, section2, item2) => section1?.id === section2?.id && item1?.id === item2?.id,
  filterItem = (section, item, filter) => { return getLabel(section, item).toLowerCase().includes(filter) },
  getDragProperties = (section, item) => { return false },
  onItemClick = (section, item) => {},
  isItemChecked = (section, item) => {},
  onCheckedChange = (section, item, checked) => {},
  selectedSection = null,
  selectedItem = null,
  pageable = false,
  itemsPerPage = 5,
  sx = {},
  forceReload = null,
  searchByCodeName = false,
  visibleSearch = true
}) => {
  const [filter, setFilter] = useState('')
  const filteredSections = useMemo(() => {
    if (!filter || filter.length === 0) {
      return sections
    }
    return sections?.map((section) => {
      const lowerCaseFilter = filter.toLowerCase()
      if (typeof section.items !== 'function') {
        const newSection = { ...section }
        newSection.items = newSection.items?.filter((item) => filterItem(section, item, lowerCaseFilter))
        return newSection
      } else {
        return section
      }
    })
  }, [sections, filter, filterItem])

  return (
    <Box direction='column' sx={{ ...sx, height: '100%', display: 'grid', gridTemplateRows: visibleSearch ? 'min-content min-content 1fr' : '1fr', backgroundColor: (theme) => theme.palette.background.card }}>
      {/* `visibleSearch={false}` when the host already provides the search (e.g. the BOM library's
          own "Search component" field filters the items before they reach the palette). */}
      {visibleSearch ? <SmartSearch sx={{ padding: 1.5, paddingRight: 2 }} setFilterText={setFilter} setLoadTable={() => {}} loadTable /> : null}
      {visibleSearch ? <Divider /> : null}
      <Box sx={{ height: '100%', overflow: 'auto', scrollbarColor: (theme) => theme.palette.text.disabled + ' ' + theme.palette.background.card }}>
        {filteredSections.map((section) =>
          <Accordion key={section.id} disableGutters sx={{ backgroundImage: 'none', backgroundColor: 'transparent', boxShadow: 'none' }} defaultExpanded={section.defaultExpanded}>
            <AccordionSummary sx={{ padding: 1.5, paddingBottom: 0 }} expandIcon={<ExpandMoreOutlined />}><Typography color='primary'>{section.title}</Typography></AccordionSummary>
            <AccordionDetails sx={{ paddingLeft: 1.5, paddingRight: 1.5, paddingTop: 0, paddingBottom: 1.5 }}>
              <SmartPaletteSection
                section={section}
                filter={filter}
                renderItem={renderItem}
                getLabel={getLabel}
                isItemDisabled={isItemDisabled}
                areSameItem={areSameItem}
                getDragProperties={getDragProperties}
                onItemClick={onItemClick}
                isItemChecked={isItemChecked}
                onCheckedChange={onCheckedChange}
                selectedSection={selectedSection}
                selectedItem={selectedItem}
                pageable={pageable}
                itemsPerPage={itemsPerPage}
                forceReload={forceReload}
                searchByCodeName
              />
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </Box>
  )
}

export default SmartPalette
